export const actionSymbol = '🙈action🙈';
export const actionOnSymbol = '🙈actionOn🙈';
export const computedSymbol = '🙈computedSymbol🙈';
export const reducerSymbol = '🙈reducer🙈';
export const thunkOnSymbol = '🙈thunkOn🙈';
export const thunkSymbol = '🙈thunk🙈';
